export enum OrderFulfillmentStatus {
  FULFILLED = 'fulfilled',
  NULL = 'null',
  PARTIAL = 'partial',
  RESTOCKED = 'restocked',
}
